<template>
  <div>
    <div class="flex items-center justify-between mt-2">
      <page-header
        heading="Wallet"
        breadcrumb="Settings  >>  Payments >>  Wallet"
      />
  </div>
  <empty-wallet v-if="isEmpty" />
  <wallet v-else/>

  </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader";
import EmptyWallet from "@/components/Ondemand/Payments/EmptyWallet.vue";
import Wallet from "@/components/Ondemand/Payments/Wallet.vue";

export default { 
  components: {
    PageHeader,
    EmptyWallet,
    Wallet,
  },
  data(){
    return {
      isEmpty: false
    }
  }
};  
</script>

<style></style>
